/*=========================================================================================
  File Name: main.js
  Description: main vue(js) file
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import App from './App.vue'

// Custom icons Material Icon Design - MDI
import '@/assets/icons/mdi.js'

// i18n
import i18n from './i18n/i18n'

// Filters
import VueFilterDateFormat from 'vue-filter-date-format';
Vue.use(VueFilterDateFormat)

// Moment
import moment from 'vue-moment'

Vue.use(moment);
// Vue.config.performance = true;
// Bugsnag
import Bugsnag from '@bugsnag/js'
Bugsnag.start('9529b50ff78ad660a3394824ded61509')

// Number animation
import VueNumber from 'vue-number-animation'
Vue.use(VueNumber)

// Vue Currency
import VueCurrencyFilter from 'vue-currency-filter'
Vue.use(VueCurrencyFilter, {
  symbol : 'R$',
  thousandsSeparator: '.',
  fractionCount: 2,
  fractionSeparator: ',',
  symbolPosition: 'front',
  symbolSpacing: true
})

import { VPopover, VClosePopover  } from 'v-tooltip';
Vue.directive('close-popover', VClosePopover)
Vue.component('v-popover', VPopover)

// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css'; // Vuesax
Vue.use(Vuesax)

import VueIntersect from 'vue-intersect-directive'
Vue.use(VueIntersect)

const options = {
  name: '',
  specs: [
    'fullscreen=yes',
    'titlebar=yes',
    'scrollbars=yes',
    'titlebar=no'
  ],
  styles: [
    'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css'
  ]
}


// Bootstrap
// import BootstrapVue from 'bootstrap-vue'
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap-vue/dist/bootstrap-vue.css';

// Vue.use(BootstrapVue);

// HotKeys
import VueShortkey from 'vue-shortkey'
Vue.use(VueShortkey)

// Vue v-money
import {Money} from 'v-money'
Vue.component('money', Money)

// CurrencyInput
import VueCurrencyInput from 'vue-currency-input'
Vue.use(VueCurrencyInput)

// Firebase
import firebase from './firebase/firebase';

// axios
import axios from "./axios.js"
Vue.prototype.$http = axios

// Theme Configurations
import '../themeConfig.js'


// Globally Registered Components
import { changeTawkUser } from './globalComponents.js'


// Styles: SCSS
import './assets/scss/main.scss'


// Tailwind
import '@/assets/css/main.css'


// Vue Router
import router from './router'

// VeeValidate
import VeeValidate, { Validator, ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import pt_BR from 'vee-validate/dist/locale/pt_BR.js'

Validator.localize({ en : pt_BR })
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VeeValidate);

// Vuex Store
import store from './store/store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)


// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import { mdiCookieMinusOutline } from '@mdi/js';

// Feather font icon
require('./assets/css/iconfont.css')

Vue.config.productionTip = false

var appVue = null;
if(!appVue) {
  appVue = new Vue({
    i18n,
    router,
    store,
    render: h => h(App),

    beforeCreate () {
      firebase.auth().onAuthStateChanged(async user => {
        try {
          const pageRequiresAuth = router.currentRoute.meta.requiredAuth === true;

          if (!user) {
            store.commit('SET_USER', undefined);
            if (pageRequiresAuth)
              router.replace('/login');
            return;
          }
          // todo: see need for this user fetch..
          let userInfo = await store.getters.getUserInfo(user.uid);
          if (!userInfo)
            return; // when creating a user, don't have enought time to create user in collection yet
          userInfo.uid = user.uid || user.id;
          await store.dispatch('updateUserInfo', userInfo);
          store.commit('SET_USER', { id: user.uid, ...userInfo });
          
          // Working with TAWK - Updating
          changeTawkUser(userInfo)

          if (store.state.pageIntent) {
            const intentPageRequiresCompanyInfo = store.state.pageIntent.meta.requiredFullCompanyData === true;
            const companyPreferece = localStorage.getItem('preferedCompany');
            if (!intentPageRequiresCompanyInfo || companyPreferece) {
              if (companyPreferece)
                await store.dispatch('logUserInCompany', companyPreferece);
              if (store.state.pageIntent.fullPath !== '/')
                router.replace(store.state.pageIntent.path);
              else
                router.replace('/bills/opened');
            }
            else
              router.replace('/companySelect/0');
            store.commit('SET_PAGE_INTENT_AFTER_LOGIN', null);
          }
          else if (router.currentRoute.name === 'page-login')
            router.push('/companySelect/0');
        } finally {
          setTimeout(() => {
            store.commit('SET_SESSION_LOADED', true);
          }, 500);
        }
      });
    },
    created() {
      
    }
  }).$mount('#app')
}
